import { axios, API } from "@/imports-files/common/common";
import {SendRequest} from '@/services/common/send-request';

export class OtherSourceService extends SendRequest
{
  async getOtherSourceName() {

    let url = API.other_source_users;
    try {
      const result = await axios.get(url,
        {
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error)
    {
      return error;
    }
  }
}
